import { TextInput, Icon } from '@pella/sash-framework';

import * as classes from './SearchInput.module.css';

/**
 * SearchInput atom
 * @param {Local.SearchInputProps} props
 */
export const SearchInput = ({
  searchValue,
  onChange,
  id = 'searchInput',
  placeholder = 'Search ...',
  hideLabel = false,
}) => (
  <TextInput
    id={id}
    data-testid={id}
    labelText=''
    hideLabel={hideLabel}
    placeholder={placeholder}
    value={searchValue}
    onChange={({ target: { value } }) => onChange(value)}
    iconLeft={<Icon name='search' />}
    iconRight={
      searchValue && (
        <Icon data-testid='clear-search' className={classes.clearIcon} name='close' onClick={() => onChange('')} />
      )
    }
  />
);
